import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import NumberInput from '../../../../Common/numberInput';

class Area extends Component {
    render() {
        const { controlArea: { type, area, temp, crack, control, rf, mpa }, updateControlArea, suggestions } = this.props;
        return (
            <div className="row" style={styles.container}>
                <div style={styles.firstColumn}>
                    <select
                        value={type}
                        style={styles.select}
                        onChange={(evt) => updateControlArea('type', evt.target.value)}>
                        {suggestions}
                    </select>
                </div>
                <div style={styles.secondColumn}>
                    <NumberInput
                        onChange={(val) => updateControlArea('temp', val)}
                        value={temp}
                        shouldNotCallOnChangeOnMount={true}
                    />
                </div>
                <div style={styles.thirdColumn}>
                    <NumberInput
                        onChange={(val) => updateControlArea('crack', val)}
                        value={crack}
                        shouldNotCallOnChangeOnMount={true}
                    />
                </div>
                <div style={styles.forthColumn}>
                    <NumberInput
                        onChange={(val) => updateControlArea('control', val)}
                        value={control}
                        shouldNotCallOnChangeOnMount={true}
                    />
                </div>
                <div style={styles.fifthColumn}>
                    <NumberInput
                        onChange={(val) => updateControlArea('rf', val)}
                        value={rf}
                        shouldNotCallOnChangeOnMount={true}
                    />
                </div>
                <div style={styles.sixthColumn}>
                    <NumberInput
                        onChange={(val) => updateControlArea('mpa', val)}
                        value={mpa}
                        shouldNotCallOnChangeOnMount={true}
                    />
                </div>
                <div style={{ width: '27%', display: 'inline-block', float: 'left' }}>
                    <input
                        style={styles.input}
                        value={area}
                        onChange={(evt) => updateControlArea('area', evt.target.value)}
                        placeholder="..."
                    />
                </div>
            </div>
        );
    }
}

var styles = {
    container: {
        margin: '0 0 6px 0'
    },
    select: {
        '-webkit-appearance': 'none',
        '-moz-appearance': 'none',
        '-webkit-border-radius': '0px',
        boxShadow: '0 1px 2px rgba(0,0,0,0.2) inset, 0 -1px 0 rgba(0,0,0,0.05) inset',
        backgroundColor: 'white',
        cursor: 'pointer',
        width: ' 100%',
        height: '35px',
        border: 'none',
        padding: '5px'
    },
    firstColumn: {
        width: '15%',
        paddingRight: '6px',
        paddingLeft: '0',
        float: 'left'
    },
    secondColumn: {
        width: '12%',
        float: 'left',
        textAlign: 'right'
    },
    thirdColumn: {
        width: '12%',
        padding: '0 6px',
        float: 'left',
        textAlign: 'right'
    },
    forthColumn: {
        width: '12%',
        float: 'left',
        textAlign: 'right'
    },
    fifthColumn: {
        width: '9%',
        padding: '0 6px',
        float: 'left'
    },
    sixthColumn: {
        width: '12%',
        paddingRight: '6px',
        float: 'left'
    },
    input: {
        '-webkit-appearance': 'none',
        border: 'none',
        display: 'block',
    }
}
export default Radium(Area)


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/ControlArea/area.js